/* Opinabile · carrello
   - barre "spedizione gratuita" (header, pannello, pagina carrello) aggiornate senza ricaricare
   - pannello dopo "Aggiungi al carrello"
   - pagina carrello: quantità, scelta spedizione o ritiro, giorno e orario di ritiro
   - proposta di altri prodotti prima del pagamento (se configurata)
   Senza JavaScript tutto funziona con i normali moduli Shopify. */
(function () {
  'use strict';
  var radice = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var conf = document.querySelector('[data-op-carrello-conf]');
  var SOGLIA = conf ? parseInt(conf.getAttribute('data-soglia'), 10) || 8900 : 8900;
  function testoConf(nome, riserva) {
    var valore = conf ? conf.getAttribute(nome) : '';
    return valore || riserva;
  }
  var TESTO_VUOTO = testoConf('data-testo-vuoto', 'Spedizione GRATUITA in Italia da 89 €');
  var TESTO_MANCA = testoConf('data-testo-manca', 'Ti mancano {importo} per la spedizione GRATUITA in Italia');
  var TESTO_OK = testoConf('data-testo-ok', 'Spedizione GRATUITA in Italia sbloccata');

  // prevendita scaduta: nasconde i messaggi sul prezzo di prevendita anche se la pagina è in cache
  document.querySelectorAll('[data-op-scadenza]').forEach(function (el) {
    var fine = parseInt(el.getAttribute('data-op-scadenza'), 10);
    if (fine && Date.now() / 1000 > fine) document.documentElement.classList.add('op-pv-chiusa');
  });

  function euro(cent) {
    var valore = cent / 100;
    return valore.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  function json(url, opzioni) {
    opzioni = opzioni || {};
    opzioni.headers = Object.assign({ Accept: 'application/json' }, opzioni.headers || {});
    return fetch(url, opzioni).then(function (r) {
      return r.json().then(function (dati) {
        if (!r.ok) throw dati;
        return dati;
      });
    });
  }

  function leggiCarrello() {
    return json(radice + 'cart.js');
  }

  /* ---------- barre di avanzamento ---------- */
  function aggiornaBarre(totale, pezzi) {
    var manca = SOGLIA - totale;
    var pct = Math.max(0, Math.min(100, (totale / SOGLIA) * 100));
    document.querySelectorAll('[data-op-barra]').forEach(function (barra) {
      var testo = barra.querySelector('[data-op-barra-testo]');
      var riempi = barra.querySelector('[data-op-barra-riempi]');
      var traccia = barra.querySelector('[role="progressbar"]');
      if (riempi) riempi.style.width = pct + '%';
      if (traccia) traccia.setAttribute('aria-valuenow', Math.round(pct));
      barra.classList.toggle('is-ok', pezzi > 0 && manca <= 0);
      barra.classList.toggle('is-vuoto', !pezzi);
      if (!testo) return;
      if (!pezzi) testo.textContent = TESTO_VUOTO;
      else if (manca > 0) testo.innerHTML = TESTO_MANCA.replace('{importo}', '<strong>' + euro(manca) + '</strong>');
      else testo.textContent = TESTO_OK;
    });
    document.querySelectorAll('[data-op-conta]').forEach(function (el) {
      el.textContent = pezzi;
      el.hidden = !pezzi;
    });
  }

  if (conf && conf.hasAttribute('data-totale')) {
    aggiornaBarre(parseInt(conf.getAttribute('data-totale'), 10) || 0, parseInt(conf.getAttribute('data-pezzi'), 10) || 0);
  }

  /* ---------- pannello dopo l'aggiunta ---------- */
  var pannello = document.querySelector('[data-op-pannello]');
  var ultimoFocus = null;

  function chiudiPannello() {
    if (!pannello || pannello.hidden) return;
    pannello.hidden = true;
    document.documentElement.classList.remove('op-pannello-aperto');
    if (ultimoFocus) ultimoFocus.focus();
  }

  function apriPannello(riga, carrello) {
    if (!pannello) {
      window.location.href = radice + 'cart';
      return;
    }
    var img = pannello.querySelector('[data-op-pannello-img]');
    var nome = pannello.querySelector('[data-op-pannello-nome]');
    var dett = pannello.querySelector('[data-op-pannello-dettaglio]');
    var tot = pannello.querySelector('[data-op-pannello-totale]');
    if (img) {
      if (riga.image) {
        img.src = riga.image + (riga.image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        img.alt = riga.product_title || '';
        img.hidden = false;
      } else img.hidden = true;
    }
    if (nome) nome.textContent = riga.product_title || riga.title || '';
    if (dett) dett.textContent = riga.quantity + ' × ' + euro(riga.final_price || riga.price);
    if (tot) tot.textContent = euro(carrello.total_price);
    ultimoFocus = document.activeElement;
    pannello.hidden = false;
    document.documentElement.classList.add('op-pannello-aperto');
    var titolo = pannello.querySelector('[data-op-pannello-titolo]');
    if (titolo) titolo.focus();
  }

  if (pannello) {
    pannello.addEventListener('click', function (e) {
      if (e.target.closest('[data-op-pannello-chiudi]')) {
        e.preventDefault();
        chiudiPannello();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') chiudiPannello();
    });
  }

  /* ---------- aggiungi al carrello ---------- */
  function errore(form, messaggio) {
    var box = form.querySelector('[data-op-errore]');
    if (box) {
      box.textContent = messaggio;
      box.hidden = false;
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-op-add]') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();
    var bottone = form.querySelector('[type="submit"]');
    var box = form.querySelector('[data-op-errore]');
    if (box) box.hidden = true;
    if (bottone) {
      bottone.disabled = true;
      bottone.setAttribute('aria-busy', 'true');
    }
    json(radice + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (riga) {
        return leggiCarrello().then(function (carrello) {
          aggiornaBarre(carrello.total_price, carrello.item_count);
          apriPannello(riga, carrello);
        });
      })
      .catch(function (err) {
        errore(form, (err && (err.description || err.message)) || 'Non è stato possibile aggiungere il prodotto. Riprova.');
      })
      .then(function () {
        if (bottone) {
          bottone.disabled = false;
          bottone.removeAttribute('aria-busy');
        }
      });
  });

  /* selettore quantità − / + */
  document.addEventListener('click', function (e) {
    var tasto = e.target.closest ? e.target.closest('[data-op-qta]') : null;
    if (!tasto) return;
    var campo = tasto.parentNode.querySelector('input[type="number"]');
    if (!campo) return;
    var min = parseInt(campo.min || '0', 10);
    var valore = (parseInt(campo.value, 10) || 0) + parseInt(tasto.getAttribute('data-op-qta'), 10);
    campo.value = Math.max(min, valore);
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- pagina carrello ---------- */
  var formCarrello = document.querySelector('[data-op-carrello-form]');
  if (!formCarrello) return;

  // quantità: si salva subito e si ricarica la pagina
  formCarrello.addEventListener('change', function (e) {
    var campo = e.target;
    if (!campo.matches('[data-op-riga]')) return;
    json(radice + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: campo.getAttribute('data-op-riga'), quantity: Math.max(0, parseInt(campo.value, 10) || 0) })
    }).then(function () {
      window.location.reload();
    });
  });

  // ritiro: giorni e orari
  var ritiroConf = {};
  try {
    ritiroConf = JSON.parse(document.querySelector('[data-op-ritiro-conf]').textContent);
  } catch (err) {}

  var sceltaConsegna = formCarrello.querySelectorAll('input[name="attributes[Consegna]"]');
  var boxRitiro = formCarrello.querySelector('[data-op-ritiro]');
  var selGiorno = formCarrello.querySelector('[data-op-ritiro-giorno]');
  var selOra = formCarrello.querySelector('[data-op-ritiro-ora]');
  var msgRitiro = formCarrello.querySelector('[data-op-ritiro-msg]');

  var NOMI_GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  var NOMI_MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

  function dataDa(iso) {
    var p = iso.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function iso(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function etichetta(d) {
    return NOMI_GIORNI[d.getDay()] + ' ' + d.getDate() + ' ' + NOMI_MESI[d.getMonth()] + ' ' + d.getFullYear();
  }
  function fasceDel(d) {
    var chiave = iso(d);
    if ((ritiroConf.chiusi || []).indexOf(chiave) > -1) return [];
    var extra = (ritiroConf.extra || {})[chiave];
    if (extra) return extra;
    var orari = ritiroConf.orari || {};
    return orari[String(d.getDay())] || [];
  }
  function minuti(hhmm) {
    var p = hhmm.split(':');
    return +p[0] * 60 + +p[1];
  }
  function hhmm(m) {
    var ore = '0' + Math.floor(m / 60);
    var min = '0' + (m % 60);
    return ore.slice(-2) + ':' + min.slice(-2);
  }
  function slot(fasce) {
    var passo = ritiroConf.passo || 30;
    var out = [];
    fasce.forEach(function (fascia) {
      var p = fascia.split('-');
      for (var m = minuti(p[0]); m + passo <= minuti(p[1]); m += passo) out.push(hhmm(m) + '–' + hhmm(m + passo));
    });
    return out;
  }

  var NOMI_BREVI = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  var SETTIMANE = [];

  // giorni aperti raggruppati per settimana (lunedì-domenica), dal primo giorno utile
  function calcolaSettimane() {
    var oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    var primo = new Date(oggi.getTime());
    primo.setDate(primo.getDate() + (ritiroConf.preavviso || 0));
    var d = dataDa(ritiroConf.dal);
    if (d < primo) d = primo;
    var fine = dataDa(ritiroConf.al);
    var gruppi = [];
    var corrente = null;
    for (; d <= fine; d.setDate(d.getDate() + 1)) {
      var fasce = fasceDel(d);
      if (!fasce.length) continue;
      var lunedi = new Date(d.getTime());
      lunedi.setDate(lunedi.getDate() - ((lunedi.getDay() + 6) % 7));
      if (!corrente || corrente.chiave !== iso(lunedi)) {
        corrente = { chiave: iso(lunedi), giorni: [] };
        gruppi.push(corrente);
      }
      corrente.giorni.push({ data: new Date(d.getTime()), fasce: fasce });
    }
    return gruppi;
  }

  // «dal 1°», «dall'8», «al 24»: le preposizioni giuste davanti ai numeri
  function dal(n) {
    if (n === 1) return 'dal 1°';
    if (n === 8 || n === 11) return 'dall\'' + n;
    return 'dal ' + n;
  }
  function al(n) {
    if (n === 1 || n === 8 || n === 11) return 'all\'' + n;
    return 'al ' + n;
  }

  function etichettaSettimana(g) {
    var a = g.giorni[0].data;
    var b = g.giorni[g.giorni.length - 1].data;
    if (a.getTime() === b.getTime()) return NOMI_GIORNI[a.getDay()] + ' ' + a.getDate() + ' ' + NOMI_MESI[a.getMonth()];
    if (a.getMonth() === b.getMonth()) return 'Settimana ' + dal(a.getDate()) + ' ' + al(b.getDate()) + ' ' + NOMI_MESI[b.getMonth()];
    return 'Settimana ' + dal(a.getDate()) + ' ' + NOMI_MESI[a.getMonth()] + ' ' + al(b.getDate()) + ' ' + NOMI_MESI[b.getMonth()];
  }

  // pranzo e/o cena della settimana, con i giorni in cui ci sono
  function fasceSettimana(g) {
    var giorniPer = {};
    var elenco = [];
    g.giorni.forEach(function (giorno) {
      giorno.fasce.forEach(function (f) {
        if (!giorniPer[f]) {
          giorniPer[f] = [];
          elenco.push(f);
        }
        giorniPer[f].push(NOMI_BREVI[giorno.data.getDay()]);
      });
    });
    elenco.sort(function (x, y) {
      return minuti(x.split('-')[0]) - minuti(y.split('-')[0]);
    });
    return elenco.map(function (f) {
      var p = f.split('-');
      var nome = minuti(p[0]) < 17 * 60 ? 'Pranzo' : 'Cena';
      return nome + ' ' + p[0] + '–' + p[1] + ' (' + giorniPer[f].join(', ') + ')';
    });
  }

  function riempiGiorni() {
    if (!selGiorno || !ritiroConf.dal) return;
    var scelto = selGiorno.getAttribute('data-scelto') || '';
    SETTIMANE = calcolaSettimane();
    var html = '<option value="">Scegli la settimana</option>';
    SETTIMANE.forEach(function (g, n) {
      var lab = etichettaSettimana(g);
      html += '<option value="' + lab + '" data-indice="' + n + '"' + (lab === scelto ? ' selected' : '') + '>' + lab + '</option>';
    });
    selGiorno.innerHTML = html;
    riempiOre();
  }

  function riempiOre() {
    if (!selOra || !selGiorno) return;
    var opt = selGiorno.options[selGiorno.selectedIndex];
    var scelto = selOra.getAttribute('data-scelto') || '';
    if (!opt || !opt.value) {
      selOra.innerHTML = '<option value="">Prima scegli la settimana</option>';
      selOra.disabled = true;
      return;
    }
    var fasce = fasceSettimana(SETTIMANE[+opt.getAttribute('data-indice')]);
    selOra.innerHTML = '<option value="">Pranzo o cena?</option>' + fasce.map(function (f) {
      return '<option value="' + f + '"' + (f === scelto ? ' selected' : '') + '>' + f + '</option>';
    }).join('');
    selOra.disabled = false;
  }

  function ritiroScelto() {
    var r = formCarrello.querySelector('input[name="attributes[Consegna]"]:checked');
    return r && r.getAttribute('data-op-tipo') === 'ritiro';
  }

  function mostraRitiro() {
    if (!boxRitiro) return;
    var si = ritiroScelto();
    boxRitiro.hidden = !si;
    if (selGiorno) selGiorno.required = si;
    if (selOra) selOra.required = si;
  }

  function salvaAttributi() {
    var attr = { Consegna: '', 'Ritiro - settimana': '', 'Ritiro - fascia': '', 'Ritiro - giorno': '', 'Ritiro - orario': '' };
    var r = formCarrello.querySelector('input[name="attributes[Consegna]"]:checked');
    if (r) attr.Consegna = r.value;
    if (ritiroScelto()) {
      attr['Ritiro - settimana'] = selGiorno ? selGiorno.value : '';
      attr['Ritiro - fascia'] = selOra ? selOra.value : '';
    }
    var nota = formCarrello.querySelector('[name="note"]');
    var corpo = { attributes: attr };
    if (nota) corpo.note = nota.value;
    return json(radice + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo)
    });
  }

  sceltaConsegna.forEach(function (radio) {
    radio.addEventListener('change', function () {
      mostraRitiro();
      salvaAttributi();
    });
  });
  if (selGiorno) selGiorno.addEventListener('change', function () {
    selOra.setAttribute('data-scelto', '');
    riempiOre();
    salvaAttributi();
  });
  if (selOra) selOra.addEventListener('change', salvaAttributi);
  riempiGiorni();
  mostraRitiro();

  // pagamento: controlli, poi eventuale proposta di altri prodotti
  var modale = document.querySelector('[data-op-upsell]');
  var CHIAVE_UPSELL = 'op-upsell-visto';

  function vaiAlPagamento() {
    window.location.href = radice + 'checkout';
  }

  formCarrello.addEventListener('submit', function (e) {
    var invio = e.submitter;
    if (!invio || invio.name !== 'checkout' || !window.fetch) return;
    e.preventDefault();
    if (msgRitiro) msgRitiro.hidden = true;
    if (!formCarrello.querySelector('input[name="attributes[Consegna]"]:checked')) {
      if (msgRitiro) {
        msgRitiro.textContent = 'Scegli se vuoi la spedizione o il ritiro da Opinabile.';
        msgRitiro.hidden = false;
        msgRitiro.focus();
      }
      return;
    }
    if (ritiroScelto() && (!selGiorno.value || !selOra.value)) {
      if (msgRitiro) {
        msgRitiro.textContent = 'Scegli la settimana e se passi a pranzo o a cena.';
        msgRitiro.hidden = false;
      }
      (selGiorno.value ? selOra : selGiorno).focus();
      return;
    }
    invio.disabled = true;
    salvaAttributi().then(function () {
      var visto = false;
      try { visto = sessionStorage.getItem(CHIAVE_UPSELL) === '1'; } catch (err) {}
      if (modale && !visto && modale.querySelector('[data-op-upsell-prodotto]')) {
        try { sessionStorage.setItem(CHIAVE_UPSELL, '1'); } catch (err) {}
        invio.disabled = false;
        apriUpsell();
      } else vaiAlPagamento();
    }).catch(function () {
      invio.disabled = false;
      formCarrello.submit();
    });
  });

  function apriUpsell() {
    ultimoFocus = document.activeElement;
    modale.hidden = false;
    document.documentElement.classList.add('op-pannello-aperto');
    var titolo = modale.querySelector('[data-op-upsell-titolo]');
    if (titolo) titolo.focus();
  }

  if (modale) {
    modale.addEventListener('click', function (e) {
      var agg = e.target.closest('[data-op-upsell-aggiungi]');
      if (agg) {
        agg.disabled = true;
        json(radice + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: +agg.getAttribute('data-op-upsell-aggiungi'), quantity: 1 }] })
        }).then(function () {
          agg.textContent = 'Aggiunto';
          agg.classList.add('is-fatto');
        }).catch(function () {
          agg.disabled = false;
        });
        return;
      }
      if (e.target.closest('[data-op-upsell-continua]')) {
        e.preventDefault();
        vaiAlPagamento();
        return;
      }
      if (e.target.closest('[data-op-upsell-chiudi]')) {
        e.preventDefault();
        modale.hidden = true;
        document.documentElement.classList.remove('op-pannello-aperto');
        if (ultimoFocus) ultimoFocus.focus();
      }
    });
  }
})();
